import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { Testimonials } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { FAQ } from './components/FAQ';
import { ValueStack } from './components/ValueStack';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-full w-full overflow-x-hidden bg-ink text-white" data-id="element-0" data-mp="31cjou2jzrr2f">
      <MetaPixel data-id="element-1" data-mp="2wip54z4dzc3c" />
      <TopBar data-id="element-2" data-mp="2wi5nljineppu" />
      <main data-id="element-3" data-mp="28u5y0mx2p5cu">
        <Hero data-id="element-4" data-mp="28tw4ipctkg2e" />
        <Stats data-id="element-5" data-mp="28te21azkd5m1" />
        <Testimonials data-id="element-6" data-mp="28suumo7jhzm9" />
        <PainPoints data-id="element-7" data-mp="28sb9kymlev40" />
        <Tomos data-id="element-8" data-mp="23vcm2yxfpmes" />
        <Bonuses data-id="element-9" data-mp="23vuoyeelqyvo" />
        <Countdown data-id="element-10" data-mp="23u9vks40xlze" />
        <Pricing data-id="element-11" data-mp="23ut97wmn5o7m" />
        <FAQ data-id="element-12" data-mp="23t8ea5wf0398" />
        <Countdown data-id="element-13" data-mp="3ijxnsm94vshs" />
        <ValueStack data-id="element-14" data-mp="3ikh98cxzsz0k" />
      </main>
      <Footer data-id="element-15" data-mp="3ijfx0558q6h9" />
    </div>;
}